export default class Validate {
    static assertIsValue(v, msg) {
        if(!this.isValue(v))
            throw new Error(msg ? msg : ('Invalid value: ' + v));
        return v;
    }
    static isValue(v) {
        return v !== undefined & v !== null && !Number.isNaN(v);
    }
}